const isNativeApp = () => {
  const { userAgent } = window.navigator;
  return userAgent.toLowerCase().includes('native') || userAgent.toLowerCase().includes('android');
};

export default isNativeApp;
